import { useEffect, useState } from "react";
import OutflowGrid from "@/components/OutflowGrid";
import EpcModelSohGrid from "@/components/EpcModelSohGrid";
import { api } from "@/lib/api";

export default function ConstructionEPC() {
  const [months, setMonths] = useState(null);

  useEffect(() => {
    // Piggyback on the outflows/epc endpoint so months line up.
    api.get("/outflows/epc", { params: { horizon: 17 } })
      .then(({ data }) => setMonths(data?.months || []))
      .catch(() => setMonths([]));
  }, []);

  return (
    <div className="space-y-5">
      <OutflowGrid
        page="epc"
        testId="outflows-epc"
        kicker="Outflows"
        title="Construction (EPC)"
        editRole="epc"
        description="One row per project with monthly EPC spend. Rows are seeded from the current project list — add more as needed."
      />
      {months && <EpcModelSohGrid months={months} />}
    </div>
  );
}
